import { getOrganization, getUser } from "../../../auth/authutils";
import { postFinalCertificateAttributesToIpfs } from "../../../ipfs/storenfra";
import { assetApi } from "../../../store/is/assetapi";
import { projectApi } from "../../../store/is/projectapi";
import { methodologyApi } from "../../../store/is/methodologyapi";
import { assignmentApi } from "../../../store/is/assignmentapi";
import store from "../../../store/store";
import { fetchCertificateData } from "../../../lib/certificateData";

const getAssetDetails = async (assetid) => {
  const { data: assetDetails, isLoading } = await store.dispatch(
    assetApi.endpoints.getAsset.initiate(assetid)
  );
  if (!isLoading) {
    return assetDetails
      ? assetDetails?.data[0]
        ? assetDetails?.data[0]
        : null
      : null;
  }
};

const getAssetsByIds = async (assetids) => {
  var assetIdsString = assetids.join(",");
  const { data: assetDetails, isLoading } = await store.dispatch(
    assetApi.endpoints.getAssetsByIds.initiate({ assetids: assetIdsString })
  );
  if (!isLoading) {
    return assetDetails
      ? assetDetails?.data
        ? assetDetails?.data
        : null
      : null;
  }
};

async function createEntitlementRecordsUtil(
  inputYields,
  entitlementRecordDetails,
  projectSponsorOrgId,
  flag,
  totalPreCredits,
  sponsorPreCreditsAvailability,
  setSpinningYield,
  createEntitlementRecordsActionInBC,
  getPreEntitlementRecords,
  postUpdateCreateEntitilementRecords,
  userid,
  refetchYields
) {
  try {
    setSpinningYield(true);
    //If blockchain fails returnTrs

    const defaultSponsorAddress = "0x0000000000000000000000000000000000000000";

    const yieldDetailsToBc = [];
    for (let i = 0; i < inputYields?.length; i++) {
      let yieldDetails = { ...inputYields[i] };
      const safeguardDifference =
        yieldDetails?.co2_realized - yieldDetails?.co2_estimated;
      const safeguardType =
        safeguardDifference > 0
          ? "over safeguard"
          : safeguardDifference < 0
          ? "under safeguard"
          : "equal";
      const safeguardRatio = Math.abs(safeguardDifference);
      const sponsorPercentage =
        yieldDetails?.co2_realized * (totalPreCredits / 100);
      const developerPercentage =
        yieldDetails?.co2_realized * ((100 - totalPreCredits) / 100);

      const entitlementPayload = {
        yield_id: yieldDetails?._id,
      };
      let developerRecords, sponsorRecords;
      const entitlementRecordData = await getPreEntitlementRecords(
        entitlementPayload
      );

      // Sort entitlementRecordData in descending order based on the 'created' time field
      const sortedEntitlementRecordData = entitlementRecordData?.data
        ?.slice()
        .sort((a, b) => {
          const dateA = new Date(a.created.$date);
          const dateB = new Date(b.created.$date);
          return dateB - dateA;
        });
      // Project Sponsor loggedin
      if (userid === projectSponsorOrgId) {
        developerRecords = sortedEntitlementRecordData?.filter(
          (record) =>
            record?.creator &&
            record?.owner_of_entitlement_records === record?.creator
        );
        sponsorRecords = sortedEntitlementRecordData?.filter(
          (record) => record?.owner_of_entitlement_records === userid
        );
      }
      // Project Developer loggedin
      else {
        developerRecords = sortedEntitlementRecordData?.filter(
          (record) => record?.owner_of_entitlement_records === userid
        );
        sponsorRecords = sortedEntitlementRecordData?.filter(
          (record) =>
            record?.owner_of_entitlement_records === projectSponsorOrgId
        );
      }
      yieldDetails["sponsorAmount"] =
        sponsorPercentage -
        (sponsorRecords?.find((record) => record?.no_of_entitlement_record)
          ?.no_of_entitlement_record || 0);
      yieldDetails["developerAmount"] =
        developerPercentage -
        (developerRecords?.find((record) => record?.no_of_entitlement_record)
          ?.no_of_entitlement_record || 0);
      yieldDetails["safeguard_type"] = safeguardType;
      yieldDetails["safeguard_ratio"] = safeguardRatio;
      yieldDetailsToBc.push(yieldDetails);
    }

    if (
      !(await createEntitlementRecordsActionInBC({
        yields: yieldDetailsToBc,
        precreditPercentage: totalPreCredits,
        sponsorPreCreditsAvailability: sponsorPreCreditsAvailability,
        entitlementRecordDetails: entitlementRecordDetails,
        sponsorOrgId: projectSponsorOrgId || defaultSponsorAddress,
        flag: flag
      }))
    )
      return;

    if (
      postUpdateCreateEntitilementRecords &&
      postUpdateCreateEntitilementRecords !== null &&
      postUpdateCreateEntitilementRecords !== undefined
    ) {
      postUpdateCreateEntitilementRecords();
    }
  } catch {
  } finally {
    refetchYields();
    setSpinningYield(false);
  }
}

async function createTradableCertificatesUtil(
  inputInterventions,
  noOfEntitlementRecords,
  inputYields,
  setSpinningYield,
  createTradableCertificateActionInBC,
  userid
) {
  try {
    setSpinningYield(true);

    //get the Final Certificate Json Meta Data
    const finalcertificateJsonPreviewData = await getFinalCertificateJsonData(
      inputInterventions,
      inputYields
    );

    // //Post the meta data to Ipfs get the URI
    const FinalCertificate_MetadataUri = await postFinalCertificateAttributesToIpfs(
      finalcertificateJsonPreviewData
    );

    // //return if it fails in blockchain
    if (
      !(await createTradableCertificateActionInBC({
        yields: inputYields,
        type: finalcertificateJsonPreviewData?.data?.[0]?.intervention_type,
        amounts: noOfEntitlementRecords,
        status: "active",
        metadata_uri: FinalCertificate_MetadataUri,
        finalCertificateJsonData: JSON.stringify(
          finalcertificateJsonPreviewData
        ),
        userid: userid
      }))
    )
      return false;
  } catch (error) {
    console.log("error", error);
  } finally {
    setSpinningYield(false);
  }
}

const ASSIGNEE_TYPES = ["Project Sponsor", "Validator", "Verifier"];

async function fetchProjectData(projectId) {
  const { data: projectDataResponse, isLoading: isProjectDataLoading } =
    await store.dispatch(
      projectApi.endpoints.getProjectCertificates.initiate({
        project_id: projectId,
      })
    );
  if (!isProjectDataLoading && projectDataResponse?.data) {
    const data = projectDataResponse.data;
    if (Array.isArray(data)) {
      return data.find((record) => record?._id === projectId);
    } else if (typeof data === "object") {
      const project = Object.values(data).find(
        (record) => record?._id === projectId
      );
      return project || data[projectId] || data[0] || data;
    }
  }
  return undefined;
}

async function buildYieldOrgIdsByAssigneeType(inputYields) {
  const byType = {};
  for (let i = 0; i < inputYields?.length; i++) {
    const yield_id = inputYields[i]?.yield_details?._id;
    if (!yield_id) continue;
    const { data: yieldAssignmentDetails, isLoading } = await store.dispatch(
      assignmentApi.endpoints.getAssignmentByParam.initiate({ yield_id })
    );
    if (isLoading || !yieldAssignmentDetails) continue;
    yieldAssignmentDetails?.forEach((assignmentObj) => {
      if (
        ASSIGNEE_TYPES.includes(assignmentObj?.assignee_type) &&
        assignmentObj?.asset_id === null &&
        assignmentObj?.project_id === null
      ) {
        const assigneeType = assignmentObj?.assignee_type;
        const orgId = assignmentObj?.organization;
        if (!byType[assigneeType]) byType[assigneeType] = new Set();
        byType[assigneeType].add(orgId);
      }
    });
  }
  const result = {};
  for (const assigneeType in byType) {
    result[assigneeType] = Array.from(byType[assigneeType]);
  }
  return result;
}

async function fetchRoleNames(projectData, yieldUserIDsByAssigneeType) {
  const creatorId = projectData?.creator;
  if (creatorId == null || String(creatorId).trim() === "") {
    throw new Error(
      "Project has no creator; cannot build certificate. Set creator on the project."
    );
  }
  const operatorDetails = await getUser(creatorId);
  const [projectSponsorDetails, validatorDetails, verifierDetails] =
    await Promise.all([
      Promise.all(
        (yieldUserIDsByAssigneeType["Project Sponsor"] ?? []).map((orgId) =>
          getOrganization(orgId)
        )
      ),
      Promise.all(
        (yieldUserIDsByAssigneeType["Validator"] ?? []).map((orgId) =>
          getOrganization(orgId)
        )
      ),
      Promise.all(
        (yieldUserIDsByAssigneeType["Verifier"] ?? []).map((orgId) =>
          getOrganization(orgId)
        )
      ),
    ]);
  const joinNames = (details) =>
    details.map((d) => d?.name).filter(Boolean).join(", ");
  return {
    operatorName: operatorDetails?.org?.name ? operatorDetails?.org?.name : "",
    projectSponsorNames: joinNames(projectSponsorDetails),
    validatorNames: joinNames(validatorDetails),
    verifierNames: joinNames(verifierDetails),
  };
}

async function buildAssetsAndSumForProject(projectId, inputYields) {
  const assetIdsList = [];
  const yieldIdsList = [];
  const periodsSet = new Set();

  for (let i = 0; i < inputYields?.length; i++) {
    if (inputYields[i]?.intervention_details?._id === projectId) {
      const assetId = inputYields[i]?.yield_details?.asset_id;
      const yieldId = inputYields[i]?.yield_details?._id;
      const period = inputYields[i]?.yield_details?.period;
      if (assetId) {
        assetIdsList.push(assetId);
      }
      if (yieldId) {
        yieldIdsList.push(yieldId);
      }
      if (period) {
        periodsSet.add(period);
      }
    }
  }

  if (periodsSet.size > 1) {
    throw new Error(
      "Certificate creation requires a single period per project. Multiple periods found for the selected yields."
    );
  }

  const [singlePeriod] = periodsSet;

  const assetsList = await getAssetsByIds(assetIdsList);
  const assetTypeById = {};
  if (Array.isArray(assetsList)) {
    assetsList.forEach((asset) => {
      if (asset && asset._id) {
        assetTypeById[asset._id] = asset.type;
      }
    });
  }
  const assetsData = {};
  const assetsArray = [];
  let sumOfEntitlementRecords = 0;
  let totalAvailableCredits = 0;
  const nfryTokens = [];

  for (let i = 0; i < inputYields?.length; i++) {
    if (inputYields[i]?.intervention_details?._id === projectId) {
      const yieldDetails = inputYields[i]?.yield_details;
      const includedCredits =
        inputYields[i]?.updated_no_of_entitlement_record !== undefined
          ? Number(inputYields[i]?.updated_no_of_entitlement_record)
          : Number(inputYields[i]?.no_of_entitlement_record);
      const availableCredits = Number(inputYields[i]?.no_of_entitlement_record) || 0;

      totalAvailableCredits += availableCredits;

      const yieldObject = {
        yield_period: yieldDetails?.period,
        yield_storage_duration: yieldDetails?.storage_duration,
        yield_co2_realized: includedCredits,
      };

      // Collect NFRY token information
      if (yieldDetails?.token_id) {
        const assetDetails = assetsList.find(
          (asset) => asset._id === yieldDetails?.asset_id
        );
        nfryTokens.push({
          tokenId: yieldDetails.token_id,
          issuanceDate: yieldDetails?.created || yieldDetails?.updated,
          period: yieldDetails?.period || null,
          assetId: yieldDetails?.asset_id,
          externalAssetId: assetDetails?.external_asset_id || "",
          productVolume:
            yieldDetails?.product_volume != null ? yieldDetails.product_volume : null,
          realizedYield: yieldDetails?.co2_realized || null,
          creditsIncluded: includedCredits,
          creditsAvailable: availableCredits,
        });
      }

      let assetObject = assetsData[yieldDetails?.asset_id];
      if (!assetObject) {
        const assetDetails = assetsList.find(
          (asset) => asset._id === yieldDetails?.asset_id
        );
        assetObject = {
          asset_name: assetDetails?.name,
          asset_parameters: assetDetails?.param,
          yields: [],
        };
        assetsData[yieldDetails?.asset_id] = assetObject;
        assetsArray.push(assetObject);
      }
      assetObject.yields.push(yieldObject);
    }
    sumOfEntitlementRecords =
      sumOfEntitlementRecords +
      (inputYields[i]?.updated_no_of_entitlement_record !== undefined
        ? Number(inputYields[i]?.updated_no_of_entitlement_record)
        : Number(inputYields[i]?.no_of_entitlement_record));
  }
  const allAssetsGeneric =
    assetIdsList.length > 0 &&
    assetIdsList.every((id) => assetTypeById[id] === "generic");
  return {
    assetsArray,
    sumOfEntitlementRecords,
    assetIdsList,
    yieldIdsList,
    period: singlePeriod,
    totalAvailableCredits,
    nfryTokens,
    allAssetsGeneric,
  };
}

async function resolveMethodologyNames(methodologyBreakdown) {
  const uniqueMethodologyIds = [
    ...new Set(
      methodologyBreakdown
        .map((row) => row.methodologyId)
        .filter((id) => id && id.trim() !== "")
    ),
  ];

  if (uniqueMethodologyIds.length === 0) {
    return new Map();
  }

  const methodologyPromises = uniqueMethodologyIds.map((methodologyId) =>
    store.dispatch(
      methodologyApi.endpoints.getMethodologyById.initiate(methodologyId)
    )
  );

  const methodologyResults = await Promise.all(methodologyPromises);
  const methodologyMap = new Map();

  for (let i = 0; i < uniqueMethodologyIds.length; i++) {
    const methodologyId = uniqueMethodologyIds[i];
    const result = methodologyResults[i];
    const methodology = result?.data;
    if (methodology?.name) {
      methodologyMap.set(methodologyId, methodology.name);
    }
  }

  return methodologyMap;
}

function buildCertificateEntry(
  projectData,
  methodologies,
  roleNames,
  assetsArray,
  sumOfEntitlementRecords
) {
  return {
    intervention_type: projectData?.type,
    intervention_name: projectData?.name,
    intervention_project_id: projectData?.project_id,
    intervention_method: methodologies,
    intervention_standards_used: projectData?.standards_used,
    intervention_summary: projectData?.ghg_project_summary,
    intervention_region: projectData?.region,
    intervention_crediting_period: projectData?.crediting_period,
    intervention_project_period: projectData?.project_period,
    intervention_operator: roleNames.operatorName,
    intervention_project_sponsor: roleNames.projectSponsorNames,
    intervention_validator_of_quality: roleNames.validatorNames,
    intervention_verifier_of_quality: roleNames.verifierNames,
    amount_of_tradable_certificates: sumOfEntitlementRecords,
    assets: assetsArray,
  };
}

const getFinalCertificateJsonData = async (projectIds, inputYields) => {
  const finalCertificateData = [];
  const projectIdsArray = Array.from(projectIds);
  for (let j = 0; j < projectIdsArray.length; j++) {
    const projectId = projectIdsArray[j];
    const projectData = await fetchProjectData(projectId);
    if (!projectData) {
      throw new Error(`Project data not found for project ID: ${projectId}`);
    }

    const yieldUserIDsByAssigneeType =
      await buildYieldOrgIdsByAssigneeType(inputYields);
    
    let methodologies = [];

    // Normalize methodology IDs from projectData (supports both populated docs and ID arrays)
    const collectMethodologyIds = () => {
      if (Array.isArray(projectData.methodologies) && projectData.methodologies.length > 0) {
        return projectData.methodologies
          .map((m) => {
            if (!m) return null;
            if (typeof m === "string") return m;
            return m.id || m._id || null;
          })
          .filter(Boolean);
      }

      if (Array.isArray(projectData.methodology_ids) && projectData.methodology_ids.length > 0) {
        return projectData.methodology_ids.filter(Boolean);
      }

      return [];
    };

    const methodologyIds = collectMethodologyIds();

    if (methodologyIds.length > 0) {
      const methodologyPromises = methodologyIds.map((methodologyId) =>
        store.dispatch(
          methodologyApi.endpoints.getMethodologyById.initiate(methodologyId)
        )
      );
      const methodologyResults = await Promise.all(methodologyPromises);
      methodologies = methodologyResults
        .map((result) => result?.data)
        .filter(Boolean)
        .map((methodology) => ({
          id: methodology.id,
          name: methodology.name,
        }));
    }

    const roleNames = await fetchRoleNames(
      projectData,
      yieldUserIDsByAssigneeType
    );
    const {
      assetsArray,
      sumOfEntitlementRecords,
      assetIdsList,
      yieldIdsList,
      period,
      totalAvailableCredits,
      nfryTokens,
      allAssetsGeneric,
    } = await buildAssetsAndSumForProject(projectId, inputYields);

    const orgId = projectData?.organization;
    if (!orgId || String(orgId).trim() === "") {
      throw new Error(
        `Project ${projectId} has no organization; cannot resolve customer mappings for certificate data.`
      );
    }

    const entry = buildCertificateEntry(
      projectData,
      methodologies,
      roleNames,
      assetsArray,
      sumOfEntitlementRecords
    );
    entry.nfryTokens = nfryTokens;

    if (allAssetsGeneric) {
      const includedAssetIds = Array.from(new Set(assetIdsList));
      const includedAssetCount = includedAssetIds.length;
      const totalProjectAssetsForCrop = includedAssetCount;
      const scopeOfCertificate = {
        includedAssetIds,
        includedAssetCount,
        totalProjectAssetsForCrop,
        includedCropCode: "",
        includedCropLabel: "",
        projectCropCodes: [],
        projectCropLabels: [],
        isSubsetOfAssets: false,
        isSubsetOfCrops: false,
        creditsIncluded: sumOfEntitlementRecords,
        creditsAvailable: totalAvailableCredits,
        isSubsetOfCredits: sumOfEntitlementRecords < totalAvailableCredits,
        nfryTokens,
        period,
      };
      entry.scope_of_certificate = scopeOfCertificate;
      entry.ghg_impact_summary = "";
      finalCertificateData.push(entry);
      continue;
    }

    const certificateData = await fetchCertificateData(
      projectId,
      assetIdsList,
      yieldIdsList,
      period,
      orgId
    );

    if (!certificateData) {
      throw new Error(
        "Failed to fetch certificate data from platform. See console logs for details."
      );
    }

    if (certificateData.assetCropYields && Array.isArray(certificateData.assetCropYields)) {
      const assetCropYieldMap = new Map(
        certificateData.assetCropYields.map((item) => [item.assetId, item.cropYield])
      );
      
      for (const token of nfryTokens) {
        const cropYield = assetCropYieldMap.get(token.assetId);
        if (cropYield != null && cropYield > 0) {
          token.productVolume = cropYield;
        } else {
          token.productVolume = null;
        }
      }
    } else {
      for (const token of nfryTokens) {
        token.productVolume = null;
      }
    }

    entry.crop_yield_emissions = certificateData.cropYieldEmissions;
    entry.cropCode = certificateData.cropCode;
    entry.cropLabel = certificateData.cropLabel || certificateData.cropCode;
    if (certificateData.emissionBreakdown) {
      entry.emission_breakdown = certificateData.emissionBreakdown;
    }

    if (!certificateData.emissionReductionOverview) {
      throw new Error(
        "Certificate data is missing emissionReductionOverview. Platform certificate-data API must return this block."
      );
    }
    entry.emission_reduction_overview = {
      baseline: certificateData.emissionReductionOverview.baseline,
      project: certificateData.emissionReductionOverview.project,
      delta: certificateData.emissionReductionOverview.delta,
      reduction_percent: certificateData.emissionReductionOverview.reductionPercent,
      emission_intensity: {
        baseline: certificateData.emissionReductionOverview.emissionIntensity.baseline,
        project: certificateData.emissionReductionOverview.emissionIntensity.project,
        reduction: certificateData.emissionReductionOverview.emissionIntensity.reduction,
      },
    };

    const totalCropYield = certificateData.cropYieldEmissions?.totalCropYield || 0;
    const totalReduction =
      certificateData.emissionReductionOverview?.delta || 0;
    const cropName = certificateData.cropLabel || certificateData.cropCode || "crop";
    const location = projectData?.region || "the project area";
    const rawPeriod = period || "";

    const formatPeriodIndex = (period) => {
      if (typeof period !== "string") {
        throw new Error(
          `Invalid period value '${String(
            period
          )}'. Expected a string in the format YYYY-N.`
        );
      }
      const parts = period.split("-");
      if (
        parts.length !== 2 ||
        !/^\d{4}$/.test(parts[0]) ||
        !/^\d+$/.test(parts[1])
      ) {
        throw new Error(
          `Invalid period format '${period}'. Expected 'YYYY-N' (e.g. 2024-1).`
        );
      }
      return `${parts[0]}-#${parts[1]}`;
    };

    const yieldPeriod =
      rawPeriod && totalCropYield > 0 && totalReduction > 0
        ? formatPeriodIndex(rawPeriod)
        : "";

    const creditsIncluded = sumOfEntitlementRecords;
    const creditsAvailable = totalAvailableCredits;
    const hasBundledNotFully =
      creditsAvailable > 0 && creditsIncluded > 0 && creditsIncluded < creditsAvailable;

    if (totalCropYield > 0 && totalReduction > 0 && yieldPeriod) {
      // For partial bundles, scale by credits included/available to say "X of Y available and verified".
      const bundledReduction = hasBundledNotFully
        ? totalReduction * (creditsIncluded / creditsAvailable)
        : totalReduction;
      const availableReduction = hasBundledNotFully ? totalReduction : null;

      entry.ghg_impact_summary = hasBundledNotFully
        ? `This certificate represents ${bundledReduction.toFixed(3)} tCO₂e of ${availableReduction.toFixed(3)} ` +
          `tCO₂e available and verified greenhouse gas emission reductions achieved in the production of ` +
          `${totalCropYield.toFixed(2)} tons of ${cropName} during the ${yieldPeriod} period in ${location}, ` +
          `certified under the Proba Standard using the applied methodologies.`
        : `This certificate represents ${totalReduction.toFixed(3)} tCO₂e of verified greenhouse ` +
          `gas emission reductions achieved in the production of ${totalCropYield.toFixed(2)} ` +
          `tons of ${cropName} during the ${yieldPeriod} period in ${location}, ` +
          `certified under the Proba Standard using the applied methodologies.`;
    } else {
      entry.ghg_impact_summary = "";
    }

    finalCertificateData.push(entry);
  }
  return { data: finalCertificateData };
};

export {
  createEntitlementRecordsUtil,
  createTradableCertificatesUtil,
  getFinalCertificateJsonData,
  getAssetDetails
};
